import { api } from "./auth";

/**
 * Get all notifications for current user
 * @param {boolean} unreadOnly - Filter to show only unread notifications
 * @param {number} skip - Number of records to skip (pagination)
 * @param {number} limit - Number of records to return (pagination)
 */
export async function getNotifications(unreadOnly = false, skip = 0, limit = 50) {
  const response = await api.get("/notifications/", {
    params: {
      unread_only: unreadOnly,
      skip,
      limit
    }
  });
  return response.data;
}

/**
 * Get unread notification count
 */
export async function getUnreadNotificationCount() {
  const response = await api.get("/notifications/unread-count");
  return response.data;
}

/**
 * Mark notifications as read
 * @param {number[]} notificationIds - Array of notification IDs to mark as read
 */
export async function markNotificationsAsRead(notificationIds) {
  const response = await api.put("/notifications/mark-read", {
    notification_ids: notificationIds
  });
  return response.data;
}

/**
 * Delete a notification
 * @param {number} notificationId - Notification ID to delete
 */
export async function deleteNotification(notificationId) {
  const response = await api.delete(`/notifications/${notificationId}`);
  return response.data;
}
